export class InterceptorConstants {
    static invalidRefreshToken = 'Invalid refresh';
    static encodedTokenIsRefreshToken = 'Encoded token is a refresh token';
    static cannotConvertAccessToken = 'Cannot convert access token to JSON';
}
